import request from '@/utils/request';

const PATH = '/point';

export const getPointInfo = () => request({
  url: `${PATH}/option`,
  method: 'get',
});
